function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-160.08 -51.985)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m183.46 60.859c-0.15345 0-0.30842 0.0056-0.46476 0.01619-0.37718-4.9654-4.5378-8.8907-9.5992-8.8907-5.3077 0-9.6262 4.3179-9.6262 9.6265 0 0.03154 2.7e-4 0.06276 1e-3 0.09435-2.2635 1.2213-3.6994 3.5978-3.6994 6.1922 0 3.8809 3.157 7.0389 7.0384 7.0389h16.35c3.8803 0 7.0384-3.1575 7.0384-7.0389 0-3.8809-3.158-7.0384-7.0384-7.0384zm0 12.573h-16.35c-3.0514 0-5.5342-2.483-5.5342-5.5342 0-2.1782 1.288-4.1608 3.2808-5.0516l0.47611-0.2128-0.0405-0.6501c-8e-3 -0.1234-0.0178-0.2464-0.0178-0.37197 0-4.4785 3.6435-8.1223 8.1221-8.1223 4.4791 0 8.1234 3.6435 8.1221 8.1274-2e-3 0.03508-4e-3 0.06924-5e-3 0.10374l-9e-3 0.91873 0.90213-0.17301c0.35653-0.0685 0.7109-0.10274 1.0536-0.10274 3.0519 0 5.5342 2.4826 5.5342 5.5347 0 3.0514-2.4834 5.5345-5.535 5.5345z",
  fill: "#22323f",
  strokeWidth: 0.26458
}));

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30.427mm",
    height: "22.952mm",
    viewBox: "0 0 30.427 22.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.b4f8be6d.svg";
export { ForwardRef as ReactComponent };